import { render } from "./KebabMenu.vue?vue&type=template&id=6b5067ca&scoped=true&ts=true"
import script from "./KebabMenu.vue?vue&type=script&lang=ts"
export * from "./KebabMenu.vue?vue&type=script&lang=ts"

import "./KebabMenu.vue?vue&type=style&index=0&id=6b5067ca&scoped=true&lang=css"
import "./KebabMenu.vue?vue&type=style&index=1&id=6b5067ca&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5067ca"]])

export default __exports__